import { EyeOutlined } from '@ant-design/icons';
import { Button, Tooltip } from 'antd';
import { ButtonProps } from 'antd/lib/button';
import { DevicesAPI } from 'api/DevicesAPI';
import { QueryKey } from 'api/queryKey';
import { PartnerHigoDevice } from 'models/higoDevice';
import React, { FC, ReactNode } from 'react';
import { useQuery } from 'react-query';
import { useFormatMessage } from 'common/hooks/useFormatMessage';

interface ShowDeviceTokenControlProps
  extends Omit<ButtonProps, 'onClick' | 'loading' | 'href'> {
  device: PartnerHigoDevice;
  tooltip?: ReactNode;
}

export const ShowDeviceTokenControl: FC<ShowDeviceTokenControlProps> = ({
  device,
  ...buttonProps
}) => {
  const intlMessage = useFormatMessage();
  const { isLoading, refetch, data } = useQuery(
    [QueryKey.DeviceToken, device.id],
    () => DevicesAPI.getDeviceToken(device.id),
    {
      enabled: false,
    }
  );

  return data ? (
    <>{data.deviceToken}</>
  ) : (
    <Tooltip title={intlMessage({ id: 'devices.showToken' })}>
      <Button
        loading={isLoading}
        onClick={() => refetch()}
        icon={<EyeOutlined />}
        {...buttonProps}
      />
    </Tooltip>
  );
};
